import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    COMPOSE_ONLY_ATTACHMENT_CONTENT_END,
    COMPOSE_ONLY_ATTACHMENT_CONTENT_START,
} from 'owa-attachment-link-common';

export type CommentText =
    | typeof COMPOSE_ONLY_ATTACHMENT_CONTENT_START
    | typeof COMPOSE_ONLY_ATTACHMENT_CONTENT_END;

export interface ReactCommentProps {
    text: CommentText;
}

class ReactComment extends React.Component<ReactCommentProps, {}> {
    componentDidMount() {
        const element = ReactDOM.findDOMNode(this) as Element;
        ReactDOM.unmountComponentAtNode(element);

        /* As `this.props.text` is only the constants
         * we define and is not dependent on user input
         * so there is no risk of cross-site scripting attack.
         */
        // tslint:disable-next-line:no-inner-html
        element.outerHTML = this.createComment();
    }

    createComment() {
        return `<!--${this.props.text}-->`;
    }

    render() {
        return <div />;
    }
}

export default ReactComment;
